import { Action } from '@ngrx/store';
import { TokenInformation } from './token-information.model';


export const Add_TokenInformation = 'Add Token Information';


export class AddTokenInformation implements Action {
    readonly type = Add_TokenInformation;

    constructor(public payload: TokenInformation ) {}
}


export type TokenInformationActions =
| AddTokenInformation;
